import { useEffect, useState, useRef } from 'react'

const useIsPausedInput = (text: string, delay = 3000): boolean => {
  const [isPaused, setIsPaused] = useState(false)
  const timerRef = useRef<number>()

  useEffect(() => {
    setIsPaused(false)
    window.clearTimeout(timerRef.current)

    timerRef.current = window.setTimeout(() => {
      setIsPaused(true)
    }, delay)

    return () => {
      window.clearTimeout(timerRef.current)
    }
  }, [text, delay])

  return isPaused
}

export default useIsPausedInput
